import React from "react";

const data = {
  Professional:
    "A formal and objective tone often used in business writing, academic writing, and other formal settings.",
  "Example 1":
    "Dear Sir/Madam, I am writing to inquire about the current job opportunities available at your company. I have attached my resume for your review and consideration.",
  Casual:
    "An informal and friendly tone often used in conversation, texting, and other informal settings.",
  "Example 2": "Hey there! How's it going? What have you been up to lately?",
  Enthusiastic:
    "An energetic and passionate tone often used to convey excitement, positivity, and enthusiasm.",
  "Example 3":
    "Wow! This is amazing! I can't believe how much fun we had last night!",
  Informational:
    "A neutral and straightforward tone often used to convey information, facts, and data in a clear and concise manner.",
  "Example 4":
    "According to the latest data from the World Health Organization, the number of confirmed cases of COVID-19 has reached over 100 million worldwide.",
  Funny:
    "A lighthearted and humorous tone often used to make people laugh or to add a touch of humor to a conversation.",
  "Example 5":
    "Why did the tomato turn red? Because it saw the salad dressing!",
  Conversational:
    "A tone designed to mimic the way people speak in conversation, often used in chatbots, customer service interactions, and other contexts where a more natural, conversational tone is desired.",
  "Example 6": "Hi there! How can I help you today?",
  Persuasive:
    "A tone used to convince or influence the reader to take a particular action or hold a certain belief, often used in advertising, political writing, and other contexts where the goal is to persuade.",
  "Example 7":
    "Join our movement today and help make a difference in your community.",
  Sarcastic:
    "A tone characterized by irony, humor, and a slight edge, often used to express humor, but can also be used to criticize or mock something in a subtle way.",
  "Example 8": "Oh, great. Another meeting. Just what I needed today.",
  Inspirational:
    "A positive and uplifting tone often used to inspire or encourage the reader to take action or to make a change.",
  "Example 9":
    "Believe in yourself and all that you are. Know that there is something inside you that is greater than any obstacle.",
  Emotional:
    "A tone designed to elicit an emotional response from the reader, such as empathy, sadness, anger, or joy, often used in storytelling, memoir writing, and other contexts where the goal is to connect with the reader on an emotional level.",
  "Example 10":
    "She looked out the window and remembered all the happy times they had shared in that little house by the lake.",
  Factual:
    "A tone characterized by an emphasis on accuracy, objectivity, and concrete information, often used in journalism, scientific writing, and other contexts where the goal is to convey information in a straightforward and credible manner.",
  "Example 11":
    "The Earth is the third planet from the Sun and is the only known planet to harbor life.",

  Creative:
    " A tone characterized by imagination, originality, and artistic expression, often used in fiction writing, poetry, and other forms of artistic expression where the goal is to engage the reader's imagination and evoke emotional responses.",
  "Example 11": "The moon was a ghostly galleon tossed upon cloudy seas.",
};

const TonesContent = ({ responseTone }) => {
  return Object.entries(data).map(([key, value], index) => {
    if (key.startsWith("Example")) {
      return null; // skip examples
    }
    return (
      <div className="tones-content" key={index} hidden={responseTone !== key}>
        <h4>{key}</h4>
        <div className="tones-disc">
          <p>{value}</p>
          {data[`Example ${index}`] && (
            <p>Example: "{data[`Example ${index}`]}"</p>
          )}
        </div>
      </div>
    );
  });
};

export default TonesContent;
